export default __webpack_public_path__ + "static/media/White0007.c576b136.png";